import { PropTypes } from 'prop-types';

import { useCurrentLocation } from '@hooks/use-current-location';
import { Alert } from '../alert';
import { Box, Flex } from '../grid';
import { Button } from '../button/new';
import { Icon } from '../icons';

const CurrentLocationButton = ({ setCoordinates, shouldUseDefaultCoordinates, variant }) => {
  const { errorMessage, isLoading, setCurrentLocation } = useCurrentLocation({
    shouldUseDefaultCoordinates,
    onSuccess: setCoordinates,
  });

  return (
    <Flex flexDirection="column" alignItems="center">
      <Button
        variant={variant}
        onClick={setCurrentLocation}
        isLoading={isLoading}
        widthType="fullWidth"
        size="tall"
        isFullWidth
      >
        {!isLoading && (
          <Flex justifyContent="center" alignItems="center">
            <Icon name="locationArrow" fill="currentColor" flexShrink="0" mr="8px" />
            Use current location
          </Flex>
        )}
      </Button>
      {errorMessage && (
        <Box mt="8px">
          <Alert type="warning">{errorMessage}</Alert>
        </Box>
      )}
    </Flex>
  );
};

CurrentLocationButton.propTypes = {
  setCoordinates: PropTypes.func.isRequired,
  shouldUseDefaultCoordinates: PropTypes.bool,
  variant: PropTypes.string,
};

CurrentLocationButton.defaultProps = {
  shouldUseDefaultCoordinates: true,
  variant: 'tertiary',
};

export { CurrentLocationButton };
